<template>
  <div>
    <div id="header" class="header">
      <div class="header_top">
        <a :href="`${headerVars.iravtr.url}`">
          <img src="../../public/static/images/vtrcom-logo.png" />
        </a>
      </div>
      <div class="header_bottom"></div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import * as constants from "@/common/constants";
export default {
  name: "Footer",
  data() {
    return {
      publicPath: config.url.base,
      vars: config.header
    };
  },
  computed: {
    headerVars() {
      const path =
        constants.varsFooterHeader[config.env][
          this.$store.getters.billingInfo.paymentChannel
        ] != undefined
          ? constants.varsFooterHeader[config.env][
              this.$store.getters.billingInfo.paymentChannel
            ]
          : constants.varsFooterHeader[config.env]["vtr_com"];
      if (path[this.$store.getters.billingInfo.context] != undefined) {
        return path[this.$store.getters.billingInfo.context];
      } else {
        return path["normal"];
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.header {
  margin-bottom: 45px;
}
.header div.header_top {
  height: 119px;
  background-color: #000000;
}
.header div.header_top > a > img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 47px;
}
.header div.header_bottom {
  background-image: url("../../public/static/images/top.png");
  height: 10px;
}

@media (max-width: 768px) {
  .header div.header_top {
    height: 50px;
  }

  .header div.header_top > a > img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 10px;
    width: 97px;
    height: 38px;
  }
}
</style>